var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28797 10.2467C8.1613 10.2467 8.03464 10.2001 7.93464 10.1001C7.7413 9.90675 7.7413 9.58675 7.93464 9.39341L9.28797 8.04008L7.93464 6.68675C7.7413 6.49341 7.7413 6.17342 7.93464 5.98008C8.12797 5.78675 8.44797 5.78675 8.6413 5.98008L10.348 7.68675C10.5413 7.88008 10.5413 8.20008 10.348 8.39341L8.6413 10.1001C8.54797 10.2001 8.41464 10.2467 8.28797 10.2467Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94797 8.54008H3.16797C2.89464 8.54008 2.66797 8.31341 2.66797 8.04008C2.66797 7.76675 2.89464 7.54008 3.16797 7.54008H9.94797C10.2213 7.54008 10.448 7.76675 10.448 8.04008C10.448 8.31341 10.2213 8.54008 9.94797 8.54008Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5013 13.8334C8.22797 13.8334 8.0013 13.6067 8.0013 13.3334C8.0013 13.0601 8.22797 12.8334 8.5013 12.8334C11.348 12.8334 13.3346 10.8467 13.3346 8.00008C13.3346 5.15341 11.348 3.16675 8.5013 3.16675C8.22797 3.16675 8.0013 2.94008 8.0013 2.66675C8.0013 2.39341 8.22797 2.16675 8.5013 2.16675C11.9346 2.16675 14.3346 4.56675 14.3346 8.00008C14.3346 11.4334 11.9346 13.8334 8.5013 13.8334Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.e8531afd49b7431b8c0d77fea40fb4f3.svg";
export { ForwardRef as ReactComponent };